import { z } from 'zod';

const emailErrorText = 'Please enter a valid email address.';

export const emailSchema = z.object({
  email: z
    .string({ required_error: emailErrorText })
    .trim()
    .email({ message: emailErrorText }),
});

export type EmailSchema = z.infer<typeof emailSchema>;
